import React, { useState, useRef, useEffect } from 'react';
import { Play, Square } from 'lucide-react';

const LENGTH = 120;

// Plays the week's healing frequency as a soft sine tone for 2 minutes
export default function TonePlayer({ frequency }) {
  const [left, setLeft] = useState(null);
  const audio = useRef(null);

  const stop = () => {
    const a = audio.current;
    if (a) {
      const t = a.ctx.currentTime;
      a.gain.gain.cancelScheduledValues(t);
      a.gain.gain.setValueAtTime(a.gain.gain.value, t);
      a.gain.gain.linearRampToValueAtTime(0, t + 1.5);
      clearInterval(a.tick);
      setTimeout(() => a.ctx.close().catch(() => {}), 1700);
    }
    audio.current = null;
    setLeft(null);
  };

  const start = () => {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const gain = ctx.createGain();
    const osc = ctx.createOscillator();
    osc.type = 'sine';
    osc.frequency.value = frequency.hz;
    const t = ctx.currentTime;
    gain.gain.setValueAtTime(0, t);
    gain.gain.linearRampToValueAtTime(0.16, t + 3);
    osc.connect(gain); gain.connect(ctx.destination); osc.start();
    const ends = Date.now() + LENGTH * 1000;
    const tick = setInterval(() => {
      const s = Math.max(0, Math.round((ends - Date.now()) / 1000));
      setLeft(s);
      if (s === 0) stop();
    }, 500);
    audio.current = { ctx, gain, tick };
    setLeft(LENGTH);
  };

  useEffect(() => () => stop(), [frequency.hz]); // eslint-disable-line react-hooks/exhaustive-deps

  const playing = left !== null;
  return (
    <div className="flex items-center gap-4" data-testid="f2-tone-player">
      <button
        onClick={playing ? stop : start}
        className={`w-14 h-14 rounded-full flex items-center justify-center transition-colors ${playing ? 'bg-[#e9b872] text-[#2b3550]' : 'bg-[#2b3550] text-[#f4ead8] hover:bg-[#1f2740]'}`}
        data-testid="f2-tone-toggle"
        aria-label={playing ? 'Stop tone' : 'Play tone'}
      >
        {playing ? <Square size={18} /> : <Play size={20} className="ml-0.5" />}
      </button>
      <div>
        <p className="font-body text-sm text-[#2b3550]" data-testid="f2-tone-status">
          {playing ? `Playing ${frequency.hz} Hz · ${Math.floor(left / 60)}:${String(left % 60).padStart(2, '0')}` : 'Tap to play 2 min'}
        </p>
        <p className="font-body text-xs text-stone-500">Headphones and a soft volume work best.</p>
      </div>
    </div>
  );
}
